import React from 'react';
import { BadgeCheck, Leaf, PackageCheck, Sprout, Truck } from 'lucide-react';
import { homeRail } from '../styles/ui';

// The five promises of the approved design, in its order. Wording is the
// site's own existing benefit language (the former "Why choose us" cards and
// hero panel) — no certification, guarantee or delivery-time promise is added.
export const BENEFITS = [
  { Icon: Leaf, title: '100% Fresh', subtitle: 'From trusted farms' },
  { Icon: PackageCheck, title: 'Hygienically Packed', subtitle: "For your family's safety" },
  { Icon: Truck, title: 'Same-Day Delivery', subtitle: 'Freshness at your doorstep' },
  { Icon: BadgeCheck, title: 'Quality Checked', subtitle: 'Every product is carefully inspected' },
  { Icon: Sprout, title: 'Wide Variety', subtitle: 'Everything you need, in one place' },
];

// One horizontal trust band under the category rail. It carries the `about`
// anchor: the header's "About Us" lands on the store's promises, which is the
// only "about" content the approved Home design has.
const BenefitsStrip = () => (
  <section id="about" aria-label="Why shop with Fresh & Homely" className="bg-[#F3F9F1] pt-5 pb-3 lg:pt-6 lg:pb-4">
    <div className={homeRail}>
      {/* Five equal columns on desktop, sharing the category card's edges;
          three + two (centred) on tablet, two on small tablets, one on a phone. */}
      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 xl:grid-cols-5 gap-y-0 sm:gap-y-1 xl:gap-y-0 rounded-[20px] bg-white/45 border border-[#E8F0E8] px-2 py-2 xl:py-0">
        {BENEFITS.map(({ Icon, title, subtitle }, index) => (
          <li
            key={title}
            className={`relative flex items-center gap-3 min-h-[64px] xl:min-h-[74px] px-3 xl:px-3 lg:col-span-2 xl:col-span-1 ${
              // Tablet: 3 + 2, the second row centred (cells span 2 of 6 tracks).
              index === 3 ? 'lg:col-start-2 xl:col-start-auto' : ''
            } ${
              index === BENEFITS.length - 1 ? 'sm:col-span-2 sm:justify-center lg:col-span-2 lg:justify-start xl:col-span-1' : ''
            } ${
              index > 0
                ? 'xl:before:absolute xl:before:left-0 xl:before:top-[24px] xl:before:bottom-[24px] xl:before:w-px xl:before:bg-[#E9F1E9]'
                : ''
            }`}
          >
            <span className="w-10 h-10 xl:w-[44px] xl:h-[44px] rounded-full bg-[#E4F3E5] text-emerald-700 flex items-center justify-center shrink-0">
              <Icon size={20} strokeWidth={1.9} aria-hidden="true" />
            </span>
            <span className="min-w-0">
              <span className="block text-[13.5px] font-extrabold text-emerald-950 leading-[17px]">{title}</span>
              <span className="block text-[12px] xl:text-[11.5px] text-[#5E6B63] leading-[15px] mt-[2px] text-balance xl:min-h-[30px] min-[1440px]:min-h-0 min-[1440px]:whitespace-nowrap">{subtitle}</span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default BenefitsStrip;
